import {
  CollectorChannelType,
  CollectorStateType,
  CollectorType,
  SurveyStateTypes,
  SurveyType,
} from 'shared/types';
import { CollectorDataType } from './types';

export const getOptions = (
  row: SurveyType,
  isSingleChannel: boolean,
  collectorData: CollectorDataType[] = [],
) => {
  const options = [];

  const { state } = row || {};

  if (isSingleChannel) {
    const currentSurveyCollectors = collectorData?.find(
      (a: CollectorDataType) => a.id === row.id,
    );
    const emailCollector: CollectorType | undefined =
      currentSurveyCollectors?.collectors?.find(
        (item: CollectorType) => item.channel === 'EMAIL',
      );
    if (state === 'ACTIVE') {
      if (emailCollector?.state === 'SCHEDULED') {
        options.push({
          id: 'pause',
          name: 'Pause',
        });
      }
      if (emailCollector?.state === 'ACTIVE') {
        options.push({
          id: 'close',
          name: 'Close',
        });
      }
    }
  } else {
    if (state === 'ACTIVE')
      options.push({
        id: 'pause',
        name: 'Pause',
      });
    if (state === 'PAUSE')
      options.push({
        id: 'edit',
        name: 'Edit',
      });
  }
  options.push({
    id: 'delete',
    name: 'Delete',
  });
  options.push({
    id: 'clone',
    name: 'Duplicate',
  });
  return options;
};

export type PossibleActionsType = 'pause' | 'activate' | 'edit' | '';

export const getActionButtonTextByState = (
  state: SurveyStateTypes | CollectorStateType,
): {
  actionId: PossibleActionsType;
  buttonTxt: string;
} => {
  switch (state) {
    case 'ACTIVE':
    case 'SCHEDULED':
      return {
        actionId: 'pause',
        buttonTxt: 'Pause',
      };
    case 'PAUSE':
      return {
        actionId: 'activate',
        buttonTxt: 'Activate',
      };
    case 'DRAFT':
      return {
        actionId: 'edit',
        buttonTxt: 'Edit',
      };
    default:
      return {
        actionId: '',
        buttonTxt: '',
      };
  }
};

export const getSurveyFrequency = (collector?: CollectorType): string => {
  switch (collector?.meta?.survey_frequency) {
    case 'oneTime':
      return 'One time';
    case 'recurring':
      return 'Recurring';
    default:
      return '-';
  }
};

export type ChannelCountType = { [key in CollectorChannelType]?: number };

export const getConfiguredCollectors = (
  collectors?: CollectorType[],
): ChannelCountType => {
  const channelCount: ChannelCountType = {};
  if (collectors) {
    collectors.forEach((collector: CollectorType) => {
      if (collector.channel) {
        channelCount[collector.channel] =
          (channelCount[collector.channel] || 0) + 1;
      }
    });
  }
  return channelCount;
};

export const getConsolidatedState = (
  surveyState: SurveyStateTypes,
  collectorState?: CollectorStateType,
): SurveyStateTypes | CollectorStateType => {
  // Use this only in SC mode
  switch (surveyState) {
    case 'PAUSE':
    case 'ACTIVE':
      return collectorState || surveyState;
    default:
      return surveyState;
  }
};
